class SearchView{
    _parentElement = document.querySelector(".search-form");

    getQuery(){
        const query =  this._parentElement.querySelector('.search-input').value 
        this._clearInput()
        return query
    }

    _clearInput(){
        this._parentElement.querySelector('.search-input').value = ''
    }

    addSearchHandler(handler){
        this._parentElement.addEventListener('submit',(e) => {
            e.preventDefault()
            handler()
        })
    }
 
}

export default new SearchView()